"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LabelsName = exports.RequestKaminoSchema = exports.PaymentKaminoSchema = void 0;
const zod_1 = require("zod");
const inter_1 = require("./inter");
const string_fns_1 = require("./utils/string.fns");
const KaminoApiContextSchema = zod_1.z.object({
    credential: zod_1.z.string().min(1, { message: 'Credencial inválida' }),
});
exports.PaymentKaminoSchema = inter_1.PaymentInterSchema.merge(zod_1.z.object({
    cpf_or_cnpj: string_fns_1.cpfCnpjValidator,
    amount: zod_1.z.number(),
}));
exports.RequestKaminoSchema = zod_1.z.object({
    labels: zod_1.z.array(zod_1.z.object({ name: zod_1.z.string(), value: zod_1.z.string() })).optional(),
    company: zod_1.z.object({
        name: zod_1.z.string().min(1),
        cnpj: zod_1.z.string().transform(string_fns_1.removeCpfCharacters),
    }),
    context: zod_1.z.object({
        type: zod_1.z.literal('api_kamino'),
        data: KaminoApiContextSchema,
    }),
    payments: zod_1.z.array(exports.PaymentKaminoSchema).min(1),
});
var LabelsName;
(function (LabelsName) {
    LabelsName["CATEGORY"] = "category";
    LabelsName["COST_CENTER"] = "cost_center";
})(LabelsName = exports.LabelsName || (exports.LabelsName = {}));
